import { Component, ViewEncapsulation, Input } from '@angular/core';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { DQOIReferenceDataQuery } from '@app/cp/dqoi/state/dqoi-reference-data.query';
import { InvoiceService } from '@app/cp/shared/services/invoice.service';
import { BaseAppEditComponent } from '@app/cp/shared/base-components/base-app-edit.component';
import { InvoiceBus } from '@app/cp/shared/models/InvoiceBus';
import { SaveMode } from '../../shared/enums/SaveMode';
import { CommonParam } from '../../shared/models/CommonParam';
import { CommonFunctions } from '../../shared/static/common-functions';
import { InvoiceMessageInfo } from '../../shared/models/InvoiceMessageInfo';
import { UseCPLoader, ICPLoader } from '@app/cp/shared/decorators/cploader/cploader-decorator';

@UseCPLoader()
@Component({
    selector: 'invoice-cm-crcorr',
    templateUrl: './Invoice-cm-crcorr.component.html',
    styleUrls: ['./Invoice-cm-crcorr.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class InvoiceCMCRCORRComponent extends BaseAppEditComponent<InvoiceBus, InvoiceService>  {
    compLoader: ICPLoader = this as any;
    constructor(globals: GlobalsService,  qry_rd: DQOIReferenceDataQuery, svc_data: InvoiceService) {
        super(globals, qry_rd);
        this.appCode = "InvoiceCMCRCORR";
        this.svc_data = svc_data;
        this.saveMode = SaveMode.individual;
        this.readOnly = false;
        //    this.createForm();

    }
    @Input() data: InvoiceBus;

    @Input() code: string;
    protected _active: boolean = false;
    @Input() set active(value: boolean) {
        this.beforeActiveSet(value);
        this._active = value;
    }
    get active(): boolean {
        return this._active;
    }
    beforeActiveSet(value: boolean) {
        if (value) {
            this.clear();
            this.readOnly = false;
        }
    }
    saving: boolean = false;
    clear() {
        this.qtyCORR = 1;
        this.saving = false;
    }
    qtyCORR: number = 1;

    onBlur(e: any) {
    }
    cancel() {
        this.close(null, false);
    }

    saveIndividual() {
        let id = CommonFunctions.hasValue(this.data) && CommonFunctions.hasGuidValue(this.data.invoiceId) ? this.data.invoiceId : null;
        if (id) {
            this.compLoader.cpLoaderOn();
            this.saving = true;
            let param: CommonParam = new CommonParam();
            param.addParam("InvoiceId", id);
            param.addParam("QtyOfCORR", this.qtyCORR);
            CommonFunctions.unsubscribe(this.subs_save);
            this.subs_save = this.svc_data.createCreditMemoAndCORR(param).subscribe((info: InvoiceMessageInfo) => {
                console.log("cm-crcorr: ", info);
                if (!info.saveError) {
                    this.saveSuccess("Credit Memo and CORR Invoice(s) Successfully Created");
                    this.close(true, false);
                }
                else {
                    this.saveError(info.message);
                }
                this.compLoader.cpLoaderOff();
                this.saving = false;
            });
        }
    }
    setup() {
    }
}

